<div class="row justify-content-between">
  <div class="col"><app-filter-selector [filter]="this.filter"></app-filter-selector></div>
  <div class="col">
    <mat-paginator #paginator
      [pageIndex]="0"
      [pageSize]="this.filter.paginator.pageSize"
      [pageSizeOptions]="[20, 40, 60, 100]">
    </mat-paginator>
  </div>
</div>

<div class="table-sdw is-fixed">
    <mat-table #table [dataSource]="dataSource" matSort aria-label="Elements"  [matSortActive]="this.filter.paginator.sortField" [matSortDirection]="this.filter.paginator.sortDir" class="is-header-sticky">

    <ng-container matColumnDef="incorpora" *ngIf="this.selectButton">
        <mat-header-cell *matHeaderCellDef title="Incorporar" i18n-title class="text-center"><i class="fa fa-plus-square has-color-grey"></i></mat-header-cell>
        <mat-cell *matCellDef="let row" class="text-center"><a (click)="this.selectCurrent(row.codi)" title="Incorporar" i18n-title><i class="fa fa-plus-square has-color-aqua"></i></a></mat-cell>
     </ng-container>

     <ng-container matColumnDef="codi">
      <mat-header-cell *matHeaderCellDef mat-sort-header i18n>Codi</mat-header-cell>
      <mat-cell *matCellDef="let row"><a (click)="onRowClicked(row)" class="is-link cursor detalle">{{row.codi}}</a></mat-cell>
    </ng-container>

      <ng-container matColumnDef="descripcio">
        <mat-header-cell *matHeaderCellDef mat-sort-header i18n>Descripció</mat-header-cell>
        <mat-cell *matCellDef="let row">{{row.descripcio}}</mat-cell>
      </ng-container>

      <ng-container matColumnDef="denunciaZB">
          <mat-header-cell *matHeaderCellDef mat-sort-header i18n>Denúncia ZB</mat-header-cell>
          <mat-cell *matCellDef="let row"><mat-checkbox [checked] = "row.denunciaZB" [disabled] = 'true'></mat-checkbox></mat-cell>
      </ng-container>

      <ng-container matColumnDef="denunciaPOL">
          <mat-header-cell *matHeaderCellDef mat-sort-header i18n>Denúncia POL</mat-header-cell>
          <mat-cell *matCellDef="let row"><mat-checkbox [checked]="row.denunciaPOL" [disabled] = 'true'></mat-checkbox></mat-cell>
      </ng-container>

      <ng-container matColumnDef="guardaLOG">
          <mat-header-cell *matHeaderCellDef mat-sort-header i18n>Registra LOG</mat-header-cell>
          <mat-cell *matCellDef="let row"><mat-checkbox [checked]="row.guardaLOG" [disabled] = 'true'></mat-checkbox></mat-cell>
      </ng-container>

      <ng-container matColumnDef="reincidents">
          <mat-header-cell *matHeaderCellDef mat-sort-header class="text-center" i18n>Reincidents</mat-header-cell>
          <mat-cell *matCellDef="let row" class="text-center"><mat-checkbox [checked]="row.reincidents" [disabled] = 'true'></mat-checkbox></mat-cell>
      </ng-container>

      <ng-container matColumnDef="generarAlarma">
          <mat-header-cell *matHeaderCellDef mat-sort-header class="text-center" i18n>Generar Alarma</mat-header-cell>
          <mat-cell *matCellDef="let row" class="text-center"><mat-checkbox [checked]="row.generarAlarma" [disabled] = 'true'></mat-checkbox></mat-cell>
      </ng-container>

    <ng-container matColumnDef="email">
                <mat-header-cell *matHeaderCellDef i18n>Email</mat-header-cell>
                <mat-cell *matCellDef="let row"><mat-checkbox [checked]="emailActive(row)" [disabled] = 'true'></mat-checkbox></mat-cell>
            </ng-container>

              <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
      <mat-row *matRowDef="let row; columns: displayedColumns;" class="has-iconset" [ngClass]="highlightedRows.indexOf(row) != -1 ? 'is-active' : ''"></mat-row>
    </mat-table>
</div>
